import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { useParams } from "react-router-dom"
import { useHistory } from "react-router"
import {
  Badge,
  Button,
  Card,
  CardBody,
  Container,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import SimpleBar from "simplebar-react"

//actions
import { FiEdit2 } from "react-icons/fi"
//redux
import { useSelector, useDispatch } from "react-redux"
import { map } from "lodash"
import MetaTag from "components/Common/Meta-tag"
import DeleteModal from "components/Common/DeleteModal"
import {
  deleteLead,
  deleteLeadNotes,
  getLeadDetails,
  getLeadNotes,
  createLeadNotes,
  getUsers,
  getUsersWithCrossBranch,
  updateLead,
  updateLeadAssignee,
} from "store/actions"
import moment from "moment"
import LeadHistory from "pages/Lead-History"
import CreateForm from "pages/Lead-Notes/Crud/Update/Update"
import { MdDelete } from "react-icons/md"
import FollowUpDataTables from "pages/followUp/DataTables"
import { useRole, ROLE_TYPES, getRoleLabel } from "hooks/useRole"
import useHandleStatusValue from "hooks/useHandleStatusValue"
import useLeadStatus from "hooks/useLeadStatus"

const LeadDetails = props => {
  const history = useHistory()
  const dispatch = useDispatch()
  const params = useParams()
  const { isRole, currentRole, canUpdateLead } = useRole()


  const [formModal, setFormModal] = useState({ status: false, data: "" })
  const [newNoteText, setNewNoteText] = useState("")

  // Assignee dropdown states
  const [showAssigneeDropdown, setShowAssigneeDropdown] = useState(false)
  const [assigneeSearch, setAssigneeSearch] = useState("")
  const [selectedAssigneeId, setSelectedAssigneeId] = useState("")

  // Status dropdown states
  const [showStatusDropdown, setShowStatusDropdown] = useState(false)
  const [selectedStatus, setSelectedStatus] = useState("")

  const { leadDetails, AllLeadNotes, members, assigneeLoading, usersWithCrossBranch, crossBranchLoading } = useSelector(state => ({
    leadDetails: state.Lead.leadDetails,
    AllLeadNotes: state.LeadNotes.leadnotes,
    members: state?.Members?.users?.users,
    assigneeLoading: state?.Members?.loading,
    usersWithCrossBranch: state?.Members?.usersWithCrossBranch?.users,
    crossBranchLoading: state?.Members?.crossBranchLoading,
  }))

  console.log("usersWithCrossBranch", usersWithCrossBranch)

  //delete
  const [isOpen, setIsOpen] = useState({ stauts: false, id: "" })

  const handleDeleteEvent = () => {
    setIsOpen({ ...isOpen, stauts: false })

    // Determine redirect path based on leadType
    const redirectPath = leadDetails?.leadType === "sales"
      ? "/lead/sales"
      : leadDetails?.leadType === "purchase"
        ? "/lead/purchase"
        : "/lead" // fallback to default lead page

    dispatch(deleteLead(params?.id, history, redirectPath))
  }

  const handleDelete = (id, history) => {
    setIsOpen({ stauts: true, id: id })
  }

  useEffect(() => {
    dispatch(getLeadDetails(params.id))
  }, [dispatch, params?.id])

  useEffect(() => {
    dispatch(getLeadNotes("", "", "", params?.id))
  }, [dispatch, params?.id])

  // Fetch users for assignee dropdown
  useEffect(() => {
    if (showAssigneeDropdown) {
      // Check if current user is admin or superAdmin
      const isAdminUser = isRole(ROLE_TYPES.ADMIN) || isRole(ROLE_TYPES.BRANCH_MANAGER)

      // Use different API based on user role
      if (isAdminUser) {
        // Admin users get cross-branch enquiry managers
        dispatch(getUsersWithCrossBranch("", "", assigneeSearch, '', "", "", ""))
      } else {
        // Other users get standard user list
        dispatch(getUsers("", "", assigneeSearch, '', "", "", ""))
      }
    }
  }, [dispatch, assigneeSearch, showAssigneeDropdown, isRole])

  // Set selected assignee from lead details
  useEffect(() => {
    if (leadDetails?.assignee?._id) {
      setSelectedAssigneeId(leadDetails.assignee._id)
    }
  }, [leadDetails])

  // Close assignee dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showAssigneeDropdown && !event.target.closest('.assignee-dropdown-container')) {
        setShowAssigneeDropdown(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [showAssigneeDropdown])

  // Set selected status from lead details
  useEffect(() => {
    if (leadDetails?.status) {
      setSelectedStatus(leadDetails.status)
    }
  }, [leadDetails])

  // Close status dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showStatusDropdown && !event.target.closest('.status-dropdown-container')) {
        setShowStatusDropdown(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [showStatusDropdown])

  // Get status options based on role
  const statusOptions = useHandleStatusValue({}, leadDetails?.leadType)
  const { getStatusColor, getStatusLabel } = useLeadStatus()

  const onCloseClick = () => {
    setFormModal({ status: false, data: "" })
  }

  // Handle assignee selection
  const handleAssigneeSelect = (assigneeId) => {
    setSelectedAssigneeId(assigneeId)
    dispatch(updateLeadAssignee(assigneeId, params?.id, () => {
      setShowAssigneeDropdown(false)
      dispatch(getLeadDetails(params.id))
    }))
  }

  // Handle status selection
  const handleStatusSelect = (statusValue) => {
    setSelectedStatus(statusValue)
    const finalValues = {
      status: statusValue,
    }
    dispatch(updateLead(finalValues, params?.id, "", () => {
      setShowStatusDropdown(false)
      dispatch(getLeadDetails(params.id))
    }, true))
  }

  // Member options for dropdown - use appropriate list based on role
  const isAdminUser = isRole(ROLE_TYPES.ADMIN)

  const userList = isAdminUser ? usersWithCrossBranch : members
  const isLoadingUsers = isAdminUser ? crossBranchLoading : assigneeLoading

  const memberOptions = userList?.map((result, index) => ({
    key: index,
    label: result?.name,
    value: result?._id,
    memberRole: result?.memberRole,
    branchName: (result?.branch?.branch_name || result?.branch?.name)
  })) || []

  const handleOwnershipStatus = ownership => {
    switch (ownership) {
      case "first_owner":
        return "First Owner"
      case "second_owner":
        return "Second Owner"
      case "third_owner":
        return "Third Owner"
      default:
        return ""
    }
  }

  const handleDeleteNotes = noteItemId => {
    dispatch(deleteLeadNotes(noteItemId, ""))
  }

  // Use hook methods for status handling
  const handleStatusColor = status => getStatusColor(status)
  const handleCheckStatus = (status, leadType) => getStatusLabel(status, leadType)

  // branch manager (admin) -> hq enquiry manager 

  /*
  const canChangeAssignee =  // everyone
    // isRole(ROLE_TYPES.SALES_MANAGER) ||
    // isRole(ROLE_TYPES.ADMIN) ||
    // isRole(ROLE_TYPES.SUPER_ADMIN) ||
    // isRole(ROLE_TYPES.ENQUIRY_MANAGER) ||
    // isRole(ROLE_TYPES.GENERAL_MANAGER) ||
    // isRole(ROLE_TYPES.ENQUIRY_ANALYST) 
    !isRole(ROLE_TYPES.SALES_EXECUTIVE)
  */
  const canChangeAssignee = true

  const handleShowDeleteIcon = () => {
    switch (currentRole) {
      case "branchManager":
      case "enquiryAnalyst":
        return false
      case "admin":
      case "generalManager":
      case "enquiryManager":
      case "managingDirector":
      case "superAdmin":
        return true

      default:
        return false
    }
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={isOpen?.stauts}
        onCloseClick={() => setIsOpen({ ...isOpen, stauts: false })}
        onDeleteClick={handleDeleteEvent}
      />

      {formModal?.status && (
        <CreateForm
          show={formModal?.status}
          onCloseClick={onCloseClick}
          updateData={formModal?.data}
        />
      )}
      <div className="page-content">
        <MetaTag title="Lead Details" />

        <Container fluid>
          <Breadcrumbs title="Lead" breadcrumbItem="Lead Details" />
          <div style={{ display: "flex", gap: "0px" }}>
            {/* Left Section - Scrollable */}
            <div
              className="hide-scrollbar"
              style={{
                width: "calc(100% - 350px)",
                height: "calc(100vh - 150px)",
                overflowY: "auto",
                overflowX: "hidden",
                paddingRight: "10px",
                scrollbarWidth: "none", /* Firefox */
                msOverflowStyle: "none" /* IE and Edge */
              }}>
              <div>
                <Card className="mb-2">
                  <CardBody className="py-3">
                    <div className="d-flex justify-content-between">
                      {/* Left Section - Client Details */}
                      <div style={{ flex: 1 }}>
                        {/* Client Name with Icon & Edit */}
                        <div className="d-flex align-items-center mb-2">
                          <div
                            className="d-flex align-items-center justify-content-center me-2"
                            style={{
                              width: "36px",
                              height: "36px",
                              backgroundColor: "#deebff",
                              borderRadius: "50%"
                            }}
                          >
                            <i className="bx bx-user text-primary" style={{ fontSize: "18px" }} />
                          </div>
                          <div className="d-flex align-items-center">
                            <h5 className="m-0 fw-semibold">{leadDetails?.client?.name}</h5>
                            <Badge
                              className={"ms-2 font-size-11 badge-soft-success"}
                              pill
                            >
                              {leadDetails?.leadType}
                            </Badge>

                            {canUpdateLead() && (
                              <Link to={`/lead/update/${leadDetails?._id}`} className="ms-2">
                                <i
                                  className="bx bx-edit-alt text-primary cursor-pointer"
                                  style={{ fontSize: "16px", marginTop: "2px" }}
                                  title="Edit Lead"
                                />
                              </Link>
                            )}
                            {handleShowDeleteIcon() && (
                              <MdDelete
                                onClick={() => handleDelete(params?.id)}
                                size={16}
                                className="text-danger cursor-pointer ms-2"
                                title="Delete Lead"
                              />
                            )}
                          </div>
                        </div>

                        {/* Contact Info - Compact Row */}
                        <div className="d-flex flex-wrap gap-3 mb-2" style={{ fontSize: "14px", fontWeight: "500" }}>
                          {leadDetails?.client?.phone && (
                            <span className="d-flex align-items-center">
                              <i className="bx bxs-phone text-primary me-1" style={{ fontSize: "14px" }} />
                              {leadDetails?.client?.countryCode || "+91"} {leadDetails?.client?.phone}
                            </span>
                          )}

                          {leadDetails?.client?.whatsappNumber && (
                            <span className="d-flex align-items-center">
                              <i className="bx bxl-whatsapp text-success me-1" style={{ fontSize: "14px" }} />
                              {leadDetails?.client?.whatsappCountryCode || leadDetails?.client?.countryCode || "+91"} {leadDetails?.client?.whatsappNumber}
                            </span>
                          )}

                          {leadDetails?.client?.email && (
                            <span className="d-flex align-items-center">
                              <i className="bx bx-envelope text-primary me-1" style={{ fontSize: "14px" }} />
                              {leadDetails?.client?.email}
                            </span>
                          )}

                        </div>

                        {/* Message & Remarks */}
                        {(leadDetails?.message || leadDetails?.remarks) && (
                          <div className="mt-2 p-2 rounded" style={{ width: 'fit-content', minWidth: "200px", maxWidth: "600px", backgroundColor: "#f8f9fa", fontSize: "12px" }}>
                            {leadDetails?.message && (
                              <p className="m-0 mb-1">
                                <span className="text-muted">Message:</span> {leadDetails?.message}
                              </p>
                            )}
                            {leadDetails?.remarks && (
                              <p className="m-0">
                                <span className="text-muted">Remarks:</span> {leadDetails?.remarks}
                              </p>
                            )}
                          </div>
                        )}

                        {/* Created By - Small Text */}
                        <p className="m-0 mt-2 text-muted" style={{ fontSize: "11px" }}>
                          Created {moment(leadDetails?.createdAt).format("DD MMM YYYY, h:mm A")}
                          {leadDetails?.createdBy && (
                            <span> by {leadDetails?.createdBy?.name}</span>
                          )}
                        </p>
                      </div>

                      {/* Right Section - Status & Assignee */}
                      <div className="d-flex flex-column gap-2" style={{ minWidth: "280px" }}>
                        {/* Status & Assignee Row */}
                        <div className="d-flex gap-2" style={{ flexDirection: "column" }}>
                          {/* Status Box */}
                          <div className="status-dropdown-container">
                            <div
                              className="p-2 px-3 rounded cursor-pointer flex-grow-1 position-relative"
                              style={{ border: "1px solid #f0f4ff" }}
                              onClick={() => setShowStatusDropdown(!showStatusDropdown)}
                            >
                              <div className="d-flex align-items-center justify-content-between mb-1">
                                <span className="text-muted" style={{ fontSize: "11px" }}> Status</span>
                                <i className={`bx ${showStatusDropdown ? 'bx-chevron-up' : 'bx-chevron-down'} text-primary`} style={{ fontSize: "18px" }} />
                              </div>
                              <Badge
                                style={{ textTransform: "capitalize" }}
                                className={
                                  "px-2 py-1 font-size-12 badge-soft-" +
                                  `${handleStatusColor(leadDetails?.status)}`
                                }
                              >
                                {handleCheckStatus(leadDetails?.status, leadDetails?.leadType)}
                              </Badge>

                              {/* Dropdown List */}
                              {showStatusDropdown && (
                                <div
                                  className="position-absolute bg-white shadow-sm rounded mt-2"
                                  style={{
                                    top: "100%",
                                    left: 0,
                                    right: 0,
                                    zIndex: 1000,
                                    maxHeight: "250px",
                                    overflowY: "auto",
                                    border: "1px solid #e0e0e0"
                                  }}
                                >
                                  {/* Options List */}
                                  <div>
                                    {statusOptions?.filter(opt => opt.value !== 'all')?.length > 0 ? (
                                      statusOptions.filter(opt => opt.value !== 'all').map((option, index) => (
                                        <div
                                          key={index}
                                          className="p-2 px-3 cursor-pointer"
                                          style={{
                                            fontSize: "13px",
                                            transition: "background-color 0.2s",
                                            backgroundColor: selectedStatus === option.value ? "#f0f4ff" : "transparent"
                                          }}
                                          onMouseEnter={(e) => e.target.style.backgroundColor = "#f8f9fa"}
                                          onMouseLeave={(e) => e.target.style.backgroundColor = selectedStatus === option.value ? "#f0f4ff" : "transparent"}
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            handleStatusSelect(option.value)
                                          }}
                                        >
                                          {option.label}
                                        </div>
                                      ))
                                    ) : (
                                      <div className="p-3 text-center text-muted" style={{ fontSize: "12px" }}>
                                        No status options available
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Assignee Box */}
                          <div className="assignee-dropdown-container">
                            <div
                              className="p-2 px-3 rounded flex-grow-1 cursor-pointer position-relative"
                              style={{ backgroundColor: "#fff8e6" }}
                              onClick={() => {
                                if (canChangeAssignee) {
                                  setShowAssigneeDropdown(!showAssigneeDropdown)
                                }
                              }}
                            >
                              <div className="d-flex align-items-center justify-content-between mb-1">
                                <span className="text-muted" style={{ fontSize: "11px" }}>🕵🏻‍♂️ Assignee</span>
                                {canChangeAssignee && (
                                  <i
                                    className={`bx ${showAssigneeDropdown ? 'bx-chevron-up' : 'bx-chevron-down'} text-warning`}
                                    style={{ fontSize: "18px" }}
                                    id="assigneeChangeId"
                                  />
                                )}
                              </div>
                              <p className="m-0 fw-medium text-dark" style={{ fontSize: "13px" }}>
                                {leadDetails.assignee?.name || "Not Assigned"}
                              </p>

                              {/* Dropdown List */}
                              {showAssigneeDropdown && (
                                <div
                                  className="position-absolute bg-white shadow-sm rounded mt-2"
                                  style={{
                                    top: "100%",
                                    left: 0,
                                    right: 0,
                                    zIndex: 1000,
                                    maxHeight: "500px",
                                    overflowY: "auto",
                                    border: "1px solid #e0e0e0"
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  {/* Search Input */}
                                  <div className="p-2 border-bottom">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      placeholder="Search assignee..."
                                      value={assigneeSearch}
                                      onChange={(e) => setAssigneeSearch(e.target.value)}
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                  </div>

                                  {/* Options List */}
                                  <div>
                                    {isLoadingUsers ? (
                                      <div className="p-3 text-center text-muted">
                                        <i className="bx bx-loader bx-spin"></i> Loading...
                                      </div>
                                    ) : memberOptions?.length > 0 ? (
                                      memberOptions.map((option) => (
                                        <div
                                          key={option.key}
                                          className="p-2 px-3 cursor-pointer"
                                          style={{
                                            fontSize: "13px",
                                            transition: "background-color 0.2s",
                                            backgroundColor: selectedAssigneeId === option.value ? "#fff8e6" : "transparent",
                                            borderBottom: "1px solid #f0f0f0"
                                          }}
                                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
                                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = selectedAssigneeId === option.value ? "#fff8e6" : "transparent"}
                                          onClick={(e) => {
                                            e.stopPropagation()
                                            handleAssigneeSelect(option.value)
                                          }}
                                        >
                                          <div className="fw-medium">{option.label}</div>
                                          {(option.memberRole || option.branchName) && (
                                            <div className="text-muted" style={{ fontSize: "11px" }}>
                                              {option.memberRole && getRoleLabel(option.memberRole)}
                                              {option.memberRole && option.branchName && ' - '}
                                              {option.branchName && option.branchName}
                                            </div>
                                          )}
                                        </div>
                                      ))
                                    ) : (
                                      <div className="p-3 text-center text-muted" style={{ fontSize: "12px" }}>
                                        No assignees found
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>

                <div className="mb-2">
                  <FollowUpDataTables />
                </div>

                <LeadHistory />
              </div>
            </div>
            {/* Right Section - Fixed */}
            <div
              style={{
                width: "320px",
                flexShrink: 0,
                position: "sticky",
                top: "90px",
                alignSelf: "flex-start",
                maxHeight: "calc(100vh - 100px)",
                overflowY: "auto",

              }}
            >
              {/* Vehicle Details Card */}
              <Card className="m-0 mb-2" style={{ overflow: "hidden" }}>
                {leadDetails?.vehicle ? (
                  <>
                    {/* Card Header */}
                    <div
                      className="px-2 py-1 d-flex align-items-center"
                      style={{
                        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      }}
                    >
                      <i className="bx bx-car text-white me-2" style={{ fontSize: "14px" }} />
                      <span className="text-white fw-semibold" style={{ fontSize: "12px" }}>
                        Vehicle Details
                      </span>
                    </div>

                    <CardBody className="p-2">
                      <div className="d-flex justify-content-between align-items-start">
                        {/* Left - Vehicle Info */}
                        <div style={{ flex: 1 }}>
                          {/* Vehicle Name */}
                          {leadDetails?.vehicle?.name && (
                            <h6 className="mb-2 fw-semibold" style={{ fontSize: "13px", color: "#2d3748" }}>
                              {leadDetails?.vehicle?.name}
                            </h6>
                          )}

                          {/* Compact Info List */}
                          <div className="d-flex flex-column" style={{ gap: "4px" }}>
                            {leadDetails?.vehicle?.brand?.name && (
                              <div className="d-flex align-items-center">
                                <i className="bx bx-badge-check text-primary me-1" style={{ fontSize: "12px" }} />
                                <span className="text-muted" style={{ fontSize: "11px", minWidth: "55px" }}>Brand:</span>
                                <span className="fw-medium" style={{ fontSize: "11px" }}>{leadDetails?.vehicle?.brand?.name}</span>
                              </div>
                            )}
                            {leadDetails?.vehicle?.model?.name && (
                              <div className="d-flex align-items-center">
                                <i className="bx bx-purchase-tag text-success me-1" style={{ fontSize: "12px" }} />
                                <span className="text-muted" style={{ fontSize: "11px", minWidth: "55px" }}>Model:</span>
                                <span className="fw-medium" style={{ fontSize: "11px" }}>{leadDetails?.vehicle?.model?.name}</span>
                              </div>
                            )}
                            {leadDetails?.vehicle?.oilType && (
                              <div className="d-flex align-items-center">
                                <i className="bx bx-gas-pump text-warning me-1" style={{ fontSize: "12px" }} />
                                <span className="text-muted" style={{ fontSize: "11px", minWidth: "55px" }}>Fuel:</span>
                                <span className="fw-medium text-capitalize" style={{ fontSize: "11px" }}>{leadDetails?.vehicle?.oilType}</span>
                              </div>
                            )}
                            {leadDetails?.vehicle?.variant?.name && (
                              <div className="d-flex align-items-center">
                                <i className="bx bx-layer me-1" style={{ fontSize: "12px", color: "#805ad5" }} />
                                <span className="text-muted" style={{ fontSize: "11px", minWidth: "55px" }}>Variant:</span>
                                <span className="fw-medium" style={{ fontSize: "11px" }}>{leadDetails?.vehicle?.variant?.name}</span>
                              </div>
                            )}
                            {leadDetails?.vehicle?.ownershipStatus && (
                              <div className="d-flex align-items-center">
                                <i className="bx bx-user-circle text-danger me-1" style={{ fontSize: "12px" }} />
                                <span className="text-muted" style={{ fontSize: "11px", minWidth: "55px" }}>Owner:</span>
                                <span className="fw-medium" style={{ fontSize: "11px" }}>{handleOwnershipStatus(leadDetails?.vehicle?.ownershipStatus)}</span>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Right - Vehicle Image */}
                        <div
                          className="ms-2 d-flex align-items-center justify-content-center"
                          style={{
                            backgroundColor: "#f8f9fa",
                            borderRadius: "8px",
                            padding: "8px",
                            width: "100px",
                            height: "80px",
                            flexShrink: 0,
                          }}
                        >
                          {leadDetails?.vehicle?.images?.[0]?.url ? (
                            <img
                              src={leadDetails?.vehicle?.images[0]?.url}
                              alt="Vehicle"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "70px",
                                objectFit: "contain",
                                borderRadius: "4px",
                              }}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.style.display = "none";
                                e.target.parentElement.innerHTML = `
                                  <div style="display: flex; flex-direction: column; align-items: center; color: #adb5bd;">
                                    <i class="bx bx-image" style="font-size: 24px;"></i>
                                    <span style="font-size: 9px;">No Image</span>
                                  </div>
                                `;
                              }}
                            />
                          ) : (
                            <div className="d-flex flex-column align-items-center text-muted">
                              <i className="bx bx-image" style={{ fontSize: "24px" }} />
                              <span style={{ fontSize: "9px" }}>No Image</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </CardBody>
                  </>
                ) : leadDetails?.requestedVehicle ? (
                  <>
                    {/* Card Header for Requested Vehicle */}
                    <div
                      className="px-2 py-1 d-flex align-items-center"
                      style={{
                        background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                      }}
                    >
                      <i className="bx bx-search-alt text-white me-2" style={{ fontSize: "14px" }} />
                      <span className="text-white fw-semibold" style={{ fontSize: "12px" }}>
                        Requested Vehicle
                      </span>
                    </div>

                    <CardBody className="p-2">
                      <div className="d-flex justify-content-between align-items-start">
                        {/* Left - Vehicle Info */}
                        <div style={{ flex: 1 }}>
                          <div className="d-flex flex-column" style={{ gap: "4px" }}>
                            {leadDetails?.requestedVehicle?.brand?.name && (
                              <div className="d-flex align-items-center">
                                <i className="bx bx-badge-check text-primary me-1" style={{ fontSize: "12px" }} />
                                <span className="text-muted" style={{ fontSize: "11px", minWidth: "50px" }}>Brand:</span>
                                <span className="fw-medium" style={{ fontSize: "11px" }}>{leadDetails?.requestedVehicle?.brand?.name}</span>
                              </div>
                            )}
                            {leadDetails?.requestedVehicle?.model?.name && (
                              <div className="d-flex align-items-center">
                                <i className="bx bx-purchase-tag text-success me-1" style={{ fontSize: "12px" }} />
                                <span className="text-muted" style={{ fontSize: "11px", minWidth: "50px" }}>Model:</span>
                                <span className="fw-medium" style={{ fontSize: "11px" }}>{leadDetails?.requestedVehicle?.model?.name}</span>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Right - Brand Logo */}
                        <div
                          className="ms-2 d-flex align-items-center justify-content-center"
                          style={{
                            backgroundColor: "#f8f9fa",
                            borderRadius: "8px",
                            padding: "6px",
                            width: "50px",
                            height: "50px",
                            flexShrink: 0,
                          }}
                        >
                          {leadDetails?.requestedVehicle?.brand?.logo?.[0]?.url ? (
                            <img
                              src={leadDetails?.requestedVehicle?.brand?.logo?.[0]?.url}
                              alt="Brand Logo"
                              style={{
                                maxWidth: "40px",
                                maxHeight: "40px",
                                objectFit: "contain",
                              }}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.style.display = "none";
                                e.target.parentElement.innerHTML = `
                                  <div style="display: flex; flex-direction: column; align-items: center; color: #adb5bd;">
                                    <i class="bx bx-image" style="font-size: 20px;"></i>
                                  </div>
                                `;
                              }}
                            />
                          ) : (
                            <div className="d-flex flex-column align-items-center text-muted">
                              <i className="bx bx-image" style={{ fontSize: "20px" }} />
                            </div>
                          )}
                        </div>
                      </div>
                    </CardBody>
                  </>
                ) : (
                  <CardBody className="py-3">
                    <div className="d-flex align-items-center justify-content-center">
                      <i className="bx bx-car text-muted me-2" style={{ fontSize: "18px" }} />
                      <p className="text-muted m-0" style={{ fontSize: "12px" }}>No Vehicle Selected</p>
                    </div>
                  </CardBody>
                )}
              </Card>

              <Card>
                <CardBody style={{ height: "580px", display: "flex", flexDirection: "column" }}>
                  <SimpleBar style={{ flex: 1, maxHeight: "450px" }}>
                    {AllLeadNotes && AllLeadNotes?.length >= 1 ? (
                      <div className="d-flex flex-column gap-2">
                        {map(AllLeadNotes, (item, index) => (
                          <div
                            key={item?._id || index}
                            className="note-item p-2 rounded position-relative"
                            style={{
                              backgroundColor: "#f8f9fa",
                              borderLeft: "3px solid #2784ff",
                              transition: "all 0.2s ease"
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.querySelector('.note-actions').style.opacity = '1'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.querySelector('.note-actions').style.opacity = '0'
                            }}
                          >
                            {/* Note Content */}
                            <p
                              className="m-0 text-dark font-size-13"
                              style={{
                                whiteSpace: "pre-wrap",
                                lineHeight: "1.4",
                                paddingRight: "50px"
                              }}
                            >
                              {item?.note}
                            </p>

                            {/* User & Time Row */}
                            <div className="d-flex align-items-center justify-content-between mt-1">
                              <span className="font-size-10 text-muted d-flex align-items-center">
                                {/* <FaRegUser size={10} className="me-1" /> */}
                                {item?.user?.name}
                              </span>
                              <span className="font-size-10 text-muted">
                                {moment(item?.createdAt).format("DD MMM, h:mm a")}
                              </span>
                            </div>

                            {/* Action Icons - Show on hover */}
                            <div
                              className="note-actions position-absolute d-flex align-items-center gap-1"
                              style={{
                                top: "8px",
                                right: "8px",
                                opacity: 0,
                                transition: "opacity 0.2s ease"
                              }}
                            >
                              <span
                                className="cursor-pointer p-1 d-flex align-items-center justify-content-center"
                                style={{ backgroundColor: "#fff", borderRadius: "50%", width: "20px", height: "20px" }}
                                onClick={() => setFormModal({ status: true, data: item })}
                              >
                                <FiEdit2 size={12} className="text-warning" />
                              </span>
                              <span
                                className="cursor-pointer p-1 d-flex align-items-center justify-content-center"
                                style={{ backgroundColor: "#fff", borderRadius: "50%", width: "20px", height: "20px" }}
                                onClick={() => handleDeleteNotes(item?._id)}
                              >
                                <MdDelete size={14} className="text-danger" />
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="d-flex align-items-center justify-content-center h-100">
                        <p className="text-muted m-0 font-size-13">
                          No notes yet. Type below to add one!
                        </p>
                      </div>
                    )}
                  </SimpleBar>

                  {/* Inline Note Input - Textarea for longer notes */}
                  <div style={{ marginTop: "10px" }}>
                    <div className="position-relative">
                      <textarea
                        className="form-control"
                        placeholder="Write a note... (Ctrl+Enter to send)"
                        value={newNoteText}
                        onChange={(e) => setNewNoteText(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && e.ctrlKey && newNoteText.trim()) {
                            dispatch(createLeadNotes({ note: newNoteText, lead: params?.id }, () => {
                              setNewNoteText("")
                            }))
                          }
                        }}
                        rows={3}
                        style={{
                          borderRadius: "12px",
                          paddingRight: "50px",
                          resize: "none",
                          fontSize: "12px"
                        }}
                      />
                      <Button
                        color="warning"
                        size="sm"
                        className="btn-rounded position-absolute"
                        disabled={!newNoteText.trim()}
                        onClick={() => {
                          if (newNoteText.trim()) {
                            dispatch(createLeadNotes({ note: newNoteText, lead: params?.id }, () => {
                              setNewNoteText("")
                            }))
                          }
                        }}
                        style={{
                          bottom: "10px",
                          right: "10px",
                          padding: "6px 10px"
                        }}
                      >
                        <i className="mdi mdi-send" />
                      </Button>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>


        </Container>
      </div>
    </React.Fragment>
  )
}

LeadDetails.propTypes = {
  product: PropTypes.object,
  match: PropTypes.any,
  onGetProductDetail: PropTypes.func,
}

export default LeadDetails
